import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DxDataGridComponent} from 'devextreme-angular';
import {GridSetting, GridSettings, GridState, User} from '../../../shared';
import {
  GetPostalCodeMappingToMasterGridModel, GetPostalCodeMappingToMasterGridResultModel,
  PostalCodeMappingGridModel, PostalCodeMappingOption, PostalCodeMasterWithReportRegionListGridModel
} from '../../../shared/models/postal-code-mapping.model';
import {Subject} from 'rxjs';
import {UserApi} from '../../../api';
import {DragulaService} from 'ng2-dragula';
import {LoaderService} from '../../../core/loader/loader.service';
import {NotificationService} from '../../../service/notification.service';
import {FilterBuilderService} from '../../../service/filter-builder.service';
import {PostalCodeMappingService} from '../../../api/postal-code-mapping.service';
import {take, takeUntil} from 'rxjs/operators';
import CustomStore from 'devextreme/data/custom_store';
import {ExtraFilteringOptions, LoadOptions} from '../../../shared/models/shared.model';
import {MappingAction, MappingMode} from '../../../shared/enum/mapping-mode.enum';

@Component({
  selector: 'app-postal-code-mapping',
  templateUrl: 'postal-code-mapping.component.html',
  styleUrls: ['postal-code-mapping.component.css']
})

export class PostalCodeMappingComponent implements OnInit, OnDestroy {
  @ViewChild('postalCodeMappingDataGrid') postalCodeMappingDataGrid: DxDataGridComponent;
  @ViewChild('postalCodeMappingToMasterDataGrid') postalCodeMappingToMasterDataGrid: DxDataGridComponent;
  @ViewChild('postalCodeMasterDataGrid') postalCodeMasterDataGrid: DxDataGridComponent;

  public postalCodeMappingToMasterData: GetPostalCodeMappingToMasterGridModel[] = [];
  public postalCodeMappingDataSource = {};
  public postalCodeMasterDataSource = {};
  public postalCodeMappingSelectedRowData: PostalCodeMappingGridModel;
  public postalCodeMasterSelectedRowData: PostalCodeMasterWithReportRegionListGridModel;

  public currentUser: User;
  public searchText;
  public isLoadPostalCodeMappingGridDataSource: boolean;
  public isLoadPostalCodeMasterGridDataSource: boolean;
  public postalCodeMappingLoadingOptions: LoadOptions;

  sourcePostalCodeHeaderDataSource;
  sourceCountrySubdivisionHeaderDataSource;
  sourceCountryHeaderDataSource;
  reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource;
  postalSystemOrCountryLevelGeographicalEntityMismatchErrorHeaderDataSource;
  postalCodeBaseLevelGeographicalEntityMismatchErrorHeaderDataSource;
  modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource;
  mappingModeNameHeaderDataSource;
  mappingModeKeyHeaderDataSource;
  isDataProviderPrimaryOrDefaultCountryInconsistentMappingMessageHeaderDataSource;
  dataProviderPrimaryOrDefaultCountryGeographicalEntityShortNameHeaderDataSource;
  dataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2CodeHeaderDataSource;
  dataProviderCodeHeaderDataSource;
  createdByUserFullNameSortableOrPrincipalNameHeaderDataSource;
  countrySubdivisionTypeNameHeaderDataSource;
  countrySubdivisionShortNameHeaderDataSource;
  countrySubdivisionParentTypeNameHeaderDataSource;
  countrySubdivisionParentShortNameHeaderDataSource;
  countrySubdivisionParentCodeHeaderDataSource;
  countrySubdivisionMappingModeNameHeaderDataSource;
  countrySubdivisionMappingModeKeyHeaderDataSource;
  countrySubdivisionCountryAlpha2CodeHeaderDataSource;
  countrySubdivisionCodeHeaderDataSource;
  countryShortNameHeaderDataSource;
  countryMappingModeNameHeaderDataSource;
  countryMappingModeKeyHeaderDataSource;
  countryAlpha2CodeMismatchErrorHeaderDataSource;
  countryAlpha2CodeHeaderDataSource;
  cleanPostalCodeHeaderDataSource;
  sourcePostalSystemGeographicalEntityIdHeaderDataSource;
  sourceCountrySubdivisionMappingIdHeaderDataSource;
  sourceCountryMappingIdHeaderDataSource;
  reviewedByUserRoleIdHeaderDataSource;
  reviewedByUserIdHeaderDataSource;
  postalCodeMasterIdHeaderDataSource;
  postalCodeMappingIdHeaderDataSource;
  modifiedByUserRoleIdHeaderDataSource;
  modifiedByUserIdHeaderDataSource;
  mappingModeIdHeaderDataSource;
  dataProviderPrimaryOrDefaultCountryGeographicalEntityIdHeaderDataSource;
  dataProviderIdHeaderDataSource;
  createdByUserRoleIdHeaderDataSource;
  createdByUserIdHeaderDataSource;
  countrySubdivisionMappingModeIdHeaderDataSource;
  countrySubdivisionGeographicalEntityIdHeaderDataSource;
  countryMappingModeIdHeaderDataSource;
  countryGeographicalEntityIdHeaderDataSource;
  mappingPriorityHeaderDataSource;
  reviewedOnHeaderDataSource;
  modifiedOnHeaderDataSource;
  createdOnHeaderDataSource;

  reviewedByUserFullNameSortableOrPrincipalNameMasterGridHeaderDataSource;
  reportRegionListHeaderDataSource;
  postalCodeTypeNameHeaderDataSource;
  postalCodeGeographicalNameHeaderDataSource;
  postalCodeCountryLevelGeographicalNameOrCodeHeaderDataSource;
  postalCodeBaseLevelGeographicalNameOrCodeHeaderDataSource;
  postalCodeHeaderDataSource;
  modifiedByUserFullNameSortableOrPrincipalNameMasterGridHeaderDataSource;
  createdByUserFullNameSortableOrPrincipalNameMasterGridHeaderDataSource;
  countrySubdivisionTypeNameMasterGridHeaderDataSource;
  countrySubdivisionShortNameMasterGridHeaderDataSource;
  countrySubdivisionParentTypeNameMasterGridHeaderDataSource;
  countrySubdivisionParentShortNameMasterGridHeaderDataSource;
  countrySubdivisionParentCodeMasterGridHeaderDataSource;
  countrySubdivisionCodeMasterGridHeaderDataSource;
  countryShortNameHeaderMasterGridDataSource;
  countryAlpha3CodeHeaderDataSource;
  countryAlpha2CodeHeaderMasterGridDataSource;
  reviewedByUserRoleIdMasterGridHeaderDataSource;
  reviewedByUserIdMasterGridHeaderDataSource;
  postalCodeTypeIdHeaderDataSource;
  postalCodeMasterIdMasterGridHeaderDataSource;
  modifiedByUserRoleIdMasterGridHeaderDataSource;
  modifiedByUserIdMasterGridHeaderDataSource;
  createdByUserRoleIdMasterGridHeaderDataSource;
  createdByUserIdMasterGridHeaderDataSource;
  countrySubdivisionGeographicalEntityIdMasterGridHeaderDataSource;
  countryGeographicalEntityIdMasterGridHeaderDataSource;
  longitudeHeaderDataSource;
  latitudeHeaderDataSource;
  reviewedOnMasterGridHeaderDataSource;
  modifiedOnMasterGridHeaderDataSource;
  createdOnMasterGridHeaderDataSource;


  private readonly mappingGridName: string = 'postalCodeMappingDataGrid';
  private readonly masterGridName: string = 'postalCodeMasterDataGrid';
  private readonly pageName: string = 'postalCodeMapping';
  private currentPostalCodeMappingDataGridState: GridState;
  private currentPostalCodeMasterDataGridState: GridState;
  private postalCodeMappingDataGridSettings: GridSettings;
  private postalCodeMasterDataGridSettings: GridSettings;
  private isPostalCodeMappingDataGridSettingLoading = true;
  private isPostalCodeMasterDataGridSettingLoading = true;
  private postalCodeMappingDataGridSetting: GridSetting = new GridSetting();
  private postalCodeMasterDataGridSetting: GridSetting = new GridSetting();
  private isPostalCodeMappingDataLoading = false;
  private isPostalCodeToMasterGridDataLoading = false;
  private isPostalCodeMasterDataLoading = false;
  private isMoveToNextRow = false;

  public extraFilteringOptions: ExtraFilteringOptions[] = [
	{ column: 'Active', value: false },
  ];

  private _destroyed$ = new Subject();
  private mappingDataGridCurrentPage: number;
  public postalCodeMasterSelectedRowMap = [];
  private postalCodeMappingSelectedRowIndex: number;

  constructor(
	private postalCodeMappingService: PostalCodeMappingService,
	private userService: UserApi,
	public dragulaService: DragulaService,
	private loaderService: LoaderService,
	private notificationService: NotificationService,
	private filterBuilder: FilterBuilderService
  ) {
	dragulaService.createGroup('HANDLES', {
		moves: (el, container, handle) => {
		return handle.className === 'fa fa-arrows';
		}
	});
  }

  ngOnInit() {
	this.loaderService.show();
	this.currentUser = this.userService.logonUser;
	if (!this.currentUser) {
		return;
	}
	this.postalCodeMappingDataGridSettings = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};

	this.userService.getGridSettings(this.postalCodeMappingDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.postalCodeMappingDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.postalCodeMappingDataGridSetting = settings.Settings;
			}
		} else {
			this.postalCodeMappingDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.postalCodeMappingDataGridSettings);
		}
		this.loadPostalCodeMappingDataGridState();
		});

	this.postalCodeMasterDataGridSettings = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};

	this.userService.getGridSettings(this.postalCodeMasterDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.postalCodeMasterDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.postalCodeMasterDataGridSetting = settings.Settings;
			}
		} else {
			this.postalCodeMasterDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.postalCodeMasterDataGridSettings);
		}
		this.loadPostalCodeMasterDataGridState();
		});
  }

  public postalCodeMappingDataContextMenu(e) {
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshPostalCodeMappingDataGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.postalCodeMappingDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.postalCodeMappingDataGridSetting.autosave = !this.postalCodeMappingDataGridSetting.autosave;
				this.postalCodeMappingDataGridSettings.Settings = JSON.stringify(this.postalCodeMappingDataGridSetting);
				this.updateGridSettings(this.postalCodeMappingDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  public customizePostalCodeMappingId(cellInfo) {
	const idStr = 'PCMp_000000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  public refreshPostalCodeMappingDataGrid() {
	this.mappingDataGridCurrentPage = this.postalCodeMappingDataGrid.instance.pageIndex();
	this.postalCodeMappingDataGrid.instance.refresh();
  }

  public loadMappingState = () => {
	return this.currentPostalCodeMappingDataGridState.State ? JSON.parse(this.currentPostalCodeMappingDataGridState.State) : null;
  }

  public saveMappingState = (state) => {
	if (this.postalCodeMappingDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.postalCodeMappingDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.postalCodeMappingDataGridSetting);
		} else {
		gridSetting = this.postalCodeMappingDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentPostalCodeMappingDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentPostalCodeMappingDataGridState);
		}
	}
  }

  public selectionMasterDataChangedHandler() {
	if (this.postalCodeMasterDataGrid.instance.getSelectedRowsData()[0]) {
		this.postalCodeMasterSelectedRowMap = this.postalCodeMasterDataGrid.instance.getSelectedRowsData()[0];
	}
  }

  public postalCodeMasterDataGridContextMenu(e) {
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshPostalCodeMasterDataGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.postalCodeMasterDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.postalCodeMasterDataGridSetting.autosave = !this.postalCodeMasterDataGridSetting.autosave;
				this.postalCodeMasterDataGridSettings.Settings = JSON.stringify(this.postalCodeMasterDataGridSetting);
				this.updateGridSettings(this.postalCodeMasterDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  public loadMasterState = () => {
	return this.currentPostalCodeMasterDataGridState.State ? JSON.parse(this.currentPostalCodeMasterDataGridState.State) : null;
  }

  public saveMasterState = (state) => {
	if (this.postalCodeMasterDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.postalCodeMasterDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.postalCodeMasterDataGridSetting);
		} else {
		gridSetting = this.postalCodeMasterDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentPostalCodeMasterDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentPostalCodeMasterDataGridState);
		}
	}
  }

  public customizePostalCodeMasterId(cellInfo) {
	const idStr = 'PCMs_000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  public refreshPostalCodeMasterDataGrid() {
	this.postalCodeMasterDataGrid.instance.refresh();
  }

  public onReady(e) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (this.postalCodeMappingSelectedRowData) {
		const currentDataItems = this.postalCodeMappingDataGrid.instance.getDataSource().items();
		const isSelectedRowExists = currentDataItems.find(item =>
		item.PostalCodeMappingId ===
		this.postalCodeMappingSelectedRowData.PostalCodeMappingId
		);
		if (currentDataItems.length === 0 || !isSelectedRowExists) {
		this.postalCodeMappingSelectedRowData = {};
		}
		if (!isSelectedRowExists) {
		grid.selectRowsByIndexes([0]);
		}
	}
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	} else {
		if (this.isMoveToNextRow && this.isNextRowAvailable) {
		this.moveToNextRow();
		this.isMoveToNextRow = false;
		} else {
		this.stayInRow();
		}
	}
  }

  private stayInRow() {
	this.setPostalCodeMappingSelectedRowIndex();
	this.postalCodeMappingDataGrid.instance.selectRowsByIndexes([this.postalCodeMappingSelectedRowIndex]);
  }

  private get isNextRowAvailable() {
	const productMappingRowData = this.postalCodeMappingDataGrid.instance.getRowElement(this.postalCodeMappingSelectedRowIndex + 1);
	if (productMappingRowData) {
		return true;
	}

	return false;
  }

  private moveToNextRow() {
	this.setPostalCodeMappingSelectedRowIndex();
	this.postalCodeMappingDataGrid.instance.selectRowsByIndexes([this.postalCodeMappingSelectedRowIndex + 1]);
  }

  public mappingGridSelectionChangedHandler() {
	if (this.postalCodeMappingDataGrid.instance.getSelectedRowsData()[0]) {
		this.postalCodeMappingSelectedRowData = this.postalCodeMappingDataGrid.instance.getSelectedRowsData()[0];
		const serviceAndPostalCodeMappingId = this.postalCodeMappingSelectedRowData.PostalCodeMappingId;
		if (serviceAndPostalCodeMappingId) {
		this.getPostalCodeMappingToMasterGridResult(serviceAndPostalCodeMappingId);
		}
		this.setPostalCodeMappingSelectedRowIndex();
	}
  }

  public masterGridSelectionChangedHandler() {
	if (this.postalCodeMasterDataGrid.instance.getSelectedRowsData()[0]) {
		this.postalCodeMasterSelectedRowData = this.postalCodeMasterDataGrid.instance.getSelectedRowsData()[0];
	}
  }

  public getPostalCodeMappingToMasterGridResult(postalCodetMappingId: number) {
	if (!postalCodetMappingId) {
		return;
	}
	this.isPostalCodeToMasterGridDataLoading = true;
	this.loaderService.show();
	this.postalCodeMappingService.getGetPostalCodeMappingToMasterGrid(postalCodetMappingId)
		.pipe(
		takeUntil(this._destroyed$)
		)
		.subscribe((res: GetPostalCodeMappingToMasterGridModel[]) => {
		this.isPostalCodeToMasterGridDataLoading = false;
		this.loaderHandler();

		this.postalCodeMappingToMasterData = res;
		this.postalCodeMappingToMasterDataGrid.instance.option('dataSource', res);
		});
  }

  // actions
  omit(postalCodeMappingId) {
	const mappingData: PostalCodeMappingOption = {};
	mappingData.MappingModeId = MappingMode.Omitted;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.PostalCodeMappingId = postalCodeMappingId;
	mappingData.ActionType = MappingAction.Omit;
	this.postalCodeMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshPostalCodeMappingDataGrid();
		});
  }

  save(postalCodeMappingId) {
	const mappingData: PostalCodeMappingOption = {};
	mappingData.MappingModeId = MappingMode.Saved;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Save;
	mappingData.PostalCodeMappingId = postalCodeMappingId;
	this.postalCodeMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshPostalCodeMappingDataGrid();
		});
  }

  deactivate(postalCodeMappingId) {
	const mappingData: PostalCodeMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Deactivate;
	mappingData.PostalCodeMappingId = postalCodeMappingId;
	this.postalCodeMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshPostalCodeMappingDataGrid();
		});
  }

  reactivate(postalCodeMappingId) {
	const mappingData: PostalCodeMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Reactivate;
	mappingData.PostalCodeMappingId = postalCodeMappingId;
	this.postalCodeMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshPostalCodeMappingDataGrid();
		});
  }

  accept(postalCodeMappingId: any) {
	const mappingData: PostalCodeMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Accept;
	mappingData.PostalCodeMappingId = postalCodeMappingId;
	mappingData.MappingModeId = MappingMode.Accepted;
	this.postalCodeMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshPostalCodeMappingDataGrid();
		});
  }

  review(postalCodeMappingId: any) {
	const mappingData: PostalCodeMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Review;
	mappingData.PostalCodeMappingId = postalCodeMappingId;
	this.postalCodeMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshPostalCodeMappingDataGrid();
		});
  }

  map(postalCodeMasterId) {
	const mappingData: PostalCodeMappingOption = {};
	mappingData.MappingModeId = MappingMode.Mapped;
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.ActionType = MappingAction.Map;
	mappingData.PostalCodeMasterId = postalCodeMasterId;
	mappingData.PostalCodeMappingId = this.postalCodeMappingSelectedRowData.PostalCodeMappingId;
	this.postalCodeMappingService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.isMoveToNextRow = true;
		this.refreshPostalCodeMappingDataGrid();
		});
  }

  private setPostalCodeMappingSelectedRowIndex() {
	const selectedRowKey = this.postalCodeMappingSelectedRowData.PostalCodeMappingId;
	const postalCodeMappingSelectedRowIndex = this.postalCodeMappingDataGrid.instance.getRowIndexByKey(selectedRowKey);
	this.postalCodeMappingSelectedRowIndex = postalCodeMappingSelectedRowIndex >= 0 ?
		postalCodeMappingSelectedRowIndex : this.postalCodeMappingSelectedRowIndex;
  }

  private loadPostalCodeMappingDataGridState() {
	const postalCodeMappingDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.mappingGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(postalCodeMappingDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentPostalCodeMappingDataGridState = state;
		} else {
			this.currentPostalCodeMappingDataGridState = {
			PageName: this.pageName,
			GridName: this.mappingGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadPostalCodeMappingGridDataSource();
		});
  }

  private loadPostalCodeMasterDataGridState() {
	const postalCodeMasterDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(postalCodeMasterDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentPostalCodeMasterDataGridState = state;
		} else {
			this.currentPostalCodeMasterDataGridState = {
			PageName: this.pageName,
			GridName: this.masterGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadPostalCodeMasterGridDataSource();
		});
  }

  private loadPostalCodeMappingGridDataSource() {
	this.isPostalCodeMappingDataGridSettingLoading = false;
	this.postalCodeMappingDataSource = new CustomStore({
		key: 'PostalCodeMappingId',
		load: (loadOptions: any) => {
		this.loaderService.show();

		this.isPostalCodeMappingDataLoading = true;
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;
		finalOptions.extraParams = this.extraFilteringOptions;
		this.postalCodeMappingLoadingOptions = finalOptions;
		return this.postalCodeMappingService.getPostalCodeMappingLightGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isPostalCodeMappingDataLoading = false;
			this.loaderHandler();
			if (this.postalCodeMappingSelectedRowData) {
				const matchedData = data.data.find(
				item => item.PostalCodeMappingId === this.postalCodeMappingSelectedRowData.PostalCodeMappingId);
				if (matchedData) {
				this.isMoveToNextRow = true;
				} else {
				this.isMoveToNextRow = false;
				}
			}
			if (!data.data || data.data.length === 0) {
				this.postalCodeMappingToMasterData = [];
			}
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isPostalCodeMappingDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		},
	});
	this.isLoadPostalCodeMappingGridDataSource = true;
	this.loadMappingGridHeaderFilterData();
  }

  private loadPostalCodeMasterGridDataSource() {
	this.isPostalCodeMasterDataGridSettingLoading = false;
	this.postalCodeMasterDataSource = new CustomStore({
		key: 'PostalCodeMasterId',
		load: (loadOptions: any) => {
		this.loaderService.show();

		this.isPostalCodeMasterDataLoading = true;
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;
		finalOptions.extraParams = this.extraFilteringOptions;
		this.postalCodeMappingLoadingOptions = finalOptions;
		return this.postalCodeMappingService.getPostalCodeMasterWithReportRegionListGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isPostalCodeMasterDataLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isPostalCodeMasterDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		},
	});
	this.isLoadPostalCodeMasterGridDataSource = true;
	this.loadMasterGridHeaderFilterData();
  }

  private loaderHandler() {
	if (
		!this.isPostalCodeMappingDataLoading &&
		!this.isPostalCodeToMasterGridDataLoading &&
		!this.isPostalCodeMasterDataLoading &&
		!this.isPostalCodeMappingDataGridSettingLoading &&
		!this.isPostalCodeMasterDataGridSettingLoading) {
		this.loaderService.hide();
	}
  }

  private formatFilterOperators(rawFilter: any[]) {
	if (!rawFilter) {
		return null;
	}
	const filterData = this.filterBuilder.handleNotFilterFormatting(rawFilter);
	return this.filterBuilder.filterFormatting(filterData);
  }

  private updateGridSettings(gridSettings: GridSettings) {
	gridSettings.SavedOn = new Date();
	this.userService.setGridSettings(gridSettings).pipe(take(1)).subscribe();
  }

  private updateGridState(gridState: GridState) {
	gridState.SavedOn = new Date();
	this.userService.setGridState(gridState).pipe(take(1)).subscribe();
  }

  private loadMappingGridHeaderFilterData() {
	this.sourcePostalCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourcePostalCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.sourceCountrySubdivisionHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourceCountrySubdivision';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.sourceCountryHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourceCountry';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.postalSystemOrCountryLevelGeographicalEntityMismatchErrorHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalSystemOrCountryLevelGeographicalEntityMismatchError';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.postalCodeBaseLevelGeographicalEntityMismatchErrorHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCodeBaseLevelGeographicalEntityMismatchError';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.mappingModeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MappingModeName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.mappingModeKeyHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MappingModeKey';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.isDataProviderPrimaryOrDefaultCountryInconsistentMappingMessageHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'IsDataProviderPrimaryOrDefaultCountryInconsistentMappingMessage';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.dataProviderPrimaryOrDefaultCountryGeographicalEntityShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderPrimaryOrDefaultCountryGeographicalEntityShortName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.dataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2CodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2Code';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.dataProviderCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.createdByUserFullNameSortableOrPrincipalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionTypeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionTypeName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionShortName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionParentTypeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentTypeName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionParentShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentShortName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionParentCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionMappingModeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionMappingModeName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionMappingModeKeyHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionMappingModeKey';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionCountryAlpha2CodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionCountryAlpha2Code';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countryShortNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryShortName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countryMappingModeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryMappingModeName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countryMappingModeKeyHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryMappingModeKey';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countryAlpha2CodeMismatchErrorHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryAlpha2CodeMismatchError';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countryAlpha2CodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryAlpha2Code';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.cleanPostalCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CleanPostalCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.sourcePostalSystemGeographicalEntityIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourcePostalSystemGeographicalEntityId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.sourceCountrySubdivisionMappingIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourceCountrySubdivisionMappingId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.sourceCountryMappingIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'SourceCountryMappingId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.reviewedByUserRoleIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserRoleId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.reviewedByUserIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.postalCodeMasterIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCodeMasterId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.postalCodeMappingIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCodeMappingId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.modifiedByUserRoleIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserRoleId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.modifiedByUserIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.mappingModeIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MappingModeId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.dataProviderPrimaryOrDefaultCountryGeographicalEntityIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderPrimaryOrDefaultCountryGeographicalEntityId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.dataProviderIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'DataProviderId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.createdByUserRoleIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserRoleId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.createdByUserIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionMappingModeIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionMappingModeId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countrySubdivisionGeographicalEntityIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionGeographicalEntityId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countryMappingModeIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryMappingModeId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.countryGeographicalEntityIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryGeographicalEntityId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.mappingPriorityHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'MappingPriority';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.reviewedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOn';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.modifiedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
	this.createdOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMapping(loadOptions);
		}
	});
  }

  private loadMasterGridHeaderFilterData() {
	this.reviewedByUserFullNameSortableOrPrincipalNameMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.reportRegionListHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReportRegionList';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.postalCodeTypeNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCodeTypeName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.postalCodeGeographicalNameHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCodeGeographicalName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.postalCodeCountryLevelGeographicalNameOrCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCodeCountryLevelGeographicalNameOrCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.postalCodeBaseLevelGeographicalNameOrCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCodeBaseLevelGeographicalNameOrCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.postalCodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.modifiedByUserFullNameSortableOrPrincipalNameMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.createdByUserFullNameSortableOrPrincipalNameMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countrySubdivisionTypeNameMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionTypeNameMaster';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countrySubdivisionShortNameMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionShortName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countrySubdivisionParentTypeNameMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentTypeName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countrySubdivisionParentShortNameMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentShortName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countrySubdivisionParentCodeMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionParentCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countrySubdivisionCodeMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionCode';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countryShortNameHeaderMasterGridDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryShortName';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countryAlpha3CodeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryAlpha3Code';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countryAlpha2CodeHeaderMasterGridDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryAlpha2Code';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.reviewedByUserRoleIdMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserRoleId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.reviewedByUserIdMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserIdMaster';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.postalCodeTypeIdHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCodeTypeId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.postalCodeMasterIdMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'PostalCodeMasterId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.modifiedByUserRoleIdMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserRoleId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.modifiedByUserIdMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.createdByUserRoleIdMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserRoleId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.createdByUserIdMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countrySubdivisionGeographicalEntityIdMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountrySubdivisionGeographicalEntityId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.countryGeographicalEntityIdMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CountryGeographicalEntityId';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.longitudeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'Longitude';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.latitudeHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'Latitude';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.reviewedOnMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOnMaster';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.modifiedOnMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
	this.createdOnMasterGridHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.valueColumn = '';
		return this.getHeaderFiltersPostalCodeMaster(loadOptions);
		}
	});
  }

  private getHeaderFiltersPostalCodeMapping(loadingOption) {
	return this.postalCodeMappingService.getHeaderFiltersPostalCodeMappingLightGrid(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  private getHeaderFiltersPostalCodeMaster(loadingOption) {
	return this.postalCodeMappingService.getHeaderFiltersPostalCodeMasterWithReportRegionListGrid(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  ngOnDestroy() {
	this.dragulaService.destroy('HANDLES');
	this.loaderService.hide();
	this._destroyed$.next(null);
	this._destroyed$.complete();
  }
}
